import { useState } from "react";
import { FaHome } from "react-icons/fa";
import { Image } from "antd";

// Mirrors the mobile Whiteboard row thumbnail: first photo, a count badge when
// there is more than one, and a house placeholder when the listing has none.
//
// `preview` turns the thumbnail into a control that opens the listing's photos
// full size. It is off by default because the Whiteboard rows are themselves
// clickable — there, a click belongs to the row, not to the picture.
const ListingThumbnail = ({ photos = [], size = 80, preview = false }) => {
  const [failed, setFailed] = useState(false);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [current, setCurrent] = useState(0);

  const src = photos[0];
  const canPreview = preview && photos.length > 0;

  const frame = (
    <>
      {src && !failed ? (
        <img
          alt=""
          src={src}
          loading="lazy"
          onError={() => setFailed(true)}
          className="h-full w-full object-cover"
        />
      ) : (
        // Most listings have no photos yet — this has to read as intentional,
        // not as a broken image.
        <FaHome color="#c7c9d3" size={20} />
      )}

      {photos.length > 1 && (
        <span className="absolute bottom-[3px] right-[3px] rounded bg-black/60 px-1 text-[10px] font-bold text-white">
          {photos.length}
        </span>
      )}
    </>
  );

  const shell = "relative flex shrink-0 items-center justify-center overflow-hidden rounded-lg bg-light_gray";

  if (!canPreview) {
    return (
      <div className={shell} style={{ height: size, width: size }}>
        {frame}
      </div>
    );
  }

  return (
    <>
      <button
        type="button"
        aria-label={`View ${photos.length} ${photos.length === 1 ? "photo" : "photos"}`}
        onClick={() => {
          setCurrent(0);
          setViewerOpen(true);
        }}
        style={{ height: size, width: size }}
        className={`${shell} cursor-zoom-in transition-opacity hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary`}
      >
        {frame}
      </button>

      {/* The viewer renders into a portal, so this only has to exist. */}
      <div className="hidden">
        <Image.PreviewGroup
          items={photos}
          preview={{
            visible: viewerOpen,
            current,
            onVisibleChange: (open) => setViewerOpen(open),
            onChange: (next) => setCurrent(next),
          }}
        />
      </div>
    </>
  );
};

export default ListingThumbnail;
